/* eslint-disable */
import getTypeof from './getTypeof';

function writeData(params) {
    const { key } = params;
    let { data } = params;
    if(window.qdp === undefined) return true;
    if (getTypeof(data) === 'object' || getTypeof(data) === 'array') {
        data = JSON.stringify(data);
    }

    // console.log('========== writeData data');
    // console.log(data);
    if (qdp.writeData) {
        _nativeWriteData(key, data);
    } else {
        _localStorageSetItem(key, data);
    }
    return true;
}

function readData(params) {
    const { key } = params;
    const { type } = params;
    let result = '{}';
    if(window.qdp === undefined) return result;
    if (qdp.readData) {
        result = _nativeReadData(key);
    } else {
        result = _localStorageGetItem(key);
    }
    // console.log('========== readData result');
    // console.log(result);
    if (type === 'json') {
        try {
            result = JSON.parse(result);
        } catch (err) {
            result = null;
            console.log(err, 'readData结果为非JSON');
        }
    }

    return result;
}

function _localStorageSetItem(key, data) {
    window.localStorage.setItem(key, data);
}

function _localStorageGetItem(key) {
    return window.localStorage.getItem(key);
}

function _nativeWriteData(key, data) {
    if(window.qdp === undefined) return;
    qdp.writeData({
        key,
        data,
        fail(res) {
            console.log("[ERROR][qdp.writeData]", res.msg)
            // throw new Error(res.msg);
        }
    });
}

function _nativeReadData(key) {
    let result = '{}';
    if(window.qdp === undefined) return result;
    qdp.readData({
        key,
        success(res) {
            result = res.data;
        },
        fail(res) {
            console.log("[ERROR][qdp.readData]", res.msg)
            // throw new Error(res.msg);
        }
    });
    return result;
}

export default {
    writeData,
    readData
};
